import { observable, action, runInAction } from 'mobx';
import { useEffect } from 'react';
import { useMount } from 'ahooks';
import { autobind } from 'core-decorators';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
// let pageLocalesData
// setTimeout(() => {
//   pageLocalesData  = getPageLocalesData();
//   console.log(pageLocalesData);
// }, 300)


/**
 * OrientationStore 负责管理屏幕方向检测和状态。
 */
class OrientationStore {
  // 响应式状态
  @observable currentOrientation = null;
  @observable isShow = true;
  @observable LocalesData = null;
  @action
  setCurrentOrientation(newOrientation) {
    if (this.currentOrientation !== newOrientation) {
      this.currentOrientation = newOrientation;
    }
  }

  /**
   * 检查页面尺寸并更新当前方向
   * 模拟原代码中的 debounce 逻辑
   */
  onPageResize = () => {
    const timer = setTimeout(() => {
      let newOrientation = null;
      if (window.innerWidth >= window.innerHeight) {
        newOrientation = 'landscape';
      } else {
        newOrientation = 'vertical';
      }

      runInAction(() => {
        this.setCurrentOrientation(newOrientation);
      });

      clearTimeout(timer);
    }, 66);
  };

  @autobind
  hideOrientation() {
    this.isShow = false;
  }

  use() {
    useMount(() => {
      this.LocalesData  = getPageLocalesData();
      this.onPageResize();
    });
    const handleResize = this.onPageResize;

    useEffect(() => {
      window.addEventListener('resize', handleResize, false);

      // cleanup function
      return () => {
        window.removeEventListener('resize', handleResize, false);
      };
    }, []); // 仅在组件挂载/卸载时运行
  }
}

export default OrientationStore;
